/**
 * Labstep
 *
 * @module components/Signature/List
 * @desc Signature list
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { SignatureEmptyState } from 'labstep-web/components/Signature/EmptyState';
import { SignatureItem } from 'labstep-web/components/Signature/Item';
import { Button } from 'labstep-web/core/Button';
import { Flex } from 'labstep-web/core/Flex';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import styles from './styles.module.scss';
import { SignatureListTimeline } from './Timeline';
import type { ISignatureListProps } from './types';

export const SignatureList: React.FC<ISignatureListProps> = ({
  experimentWorkflow,
}) => {
  if (!experimentWorkflow.entity_state_workflow) {
    return (
      <div className={styles.list} data-testid="signature-list">
        {experimentWorkflow.signatures.map((signature) => (
          <SignatureItem
            key={signature.id}
            signature={signature}
            experimentWorkflow={experimentWorkflow}
          />
        ))}
      </div>
    );
  }

  const showEmptyState =
    experimentWorkflow.getNumberOfSignaturesRequiredLeft(
      experimentWorkflow.entity_state,
    ) === 0 && experimentWorkflow.signatures.length === 0;

  return (
    <Flex column data-testid="workflow-signature-list">
      {showEmptyState ? (
        <SignatureEmptyState
          explanationText={`The workflow for this ${ExperimentWorkflow.getHumanReadableEntityName()} does not require any signatures at this stage. `}
          action={
            <EntityLink
              entity={experimentWorkflow.entity_state_workflow}
            >
              <Button>Go to Workflow</Button>
            </EntityLink>
          }
        />
      ) : (
        <SignatureListTimeline
          experimentWorkflow={experimentWorkflow}
        />
      )}
    </Flex>
  );
};
